export default __webpack_public_path__ + "static/media/github.81d381ae.svg";